import { Link } from 'react-router-dom';
import { Seo, Container } from '../components/marketing/Primitives';

export default function NotFoundPage() {
  return (
    <>
      <Seo title="Page not found" />
      <section className="py-28">
        <Container className="text-center">
          <p className="font-serif text-5xl">Page not found</p>
          <p className="mx-auto mt-4 max-w-measure text-slate">
            This page does not exist, or it moved during the rebuild of the site.
          </p>
          <div className="mt-8">
            <Link to="/" className="btn-primary">
              Go to the homepage
            </Link>
          </div>
        </Container>
      </section>
    </>
  );
}
